import React, { useEffect, useRef, useState } from 'react'
import * as S from './styles'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import { toast } from 'react-toastify'
import { useServices } from 'presentation/hooks/use-services'
import moment from 'moment'
import DividerNew from 'presentation/shared/components/DividerNew'
import { StatusTag } from 'presentation/shared/components/StatusTag'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { useFormik } from 'formik'
import * as yup from 'yup'
import {
  PendencyType,
  ResponsibleSurgicalPendency,
  ResponsibleSurgicalPendencyTypeEnum
} from 'domain/entities/surgical-pendency'
import DocumentsAttached from 'presentation/hospital/components/DocumentsAttached'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { useHistory } from 'react-router'
import { Profile, ProfileLocated } from 'common/enum/profile'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { PendenciesTab } from './Tabs/PendenciesTab'
import { convertNameToTitleCase } from './functions'
import {
  HealthInsuranceEnum,
  PendencyHistoryType,
  PendencyTypes
} from './types'
import { TimeLineTab } from './Tabs/TimelineTab'
import { HealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'
import { EligibilityTab } from './Tabs/EligibilityTab'
import { LoadSurgicalOrderNoticeCard } from 'domain/usecases/surgical-pendency/load-surgical-order-notice-card'
import { AuthorizationTab } from './Tabs/AuthorizationTab'
import Modal from 'presentation/shared/components/Modal'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import { SurgicalOrderProcedureModel } from 'domain/entities/surgical-order-procedure-model'
import { ReactComponent as OtherSurgeriesIcon } from 'presentation/assets/icons/other-surgeries-icon.svg'
import { ReactComponent as AlertIcon } from 'presentation/assets/icons/alert-triangle-filled.svg'
import { PasswordMaxDateValidationStatus } from 'common/enum/password-max-date-validation-status'
import { AuthorizationStatusTranslated } from 'common/enum/authorization-status'
import { SurgicalTimeLineActions } from 'common/enum/surgical-order-time-line-actions'
import {
  SurgicalOrderStatus,
  SurgicalOrderStatusReturnEnum
} from 'common/enum/surgical-order-status'
import { capitalizeText } from 'common/utils/capitalizeText'
import { getNameInitials } from 'common/utils/getNameInitials'
import { getShortName } from 'common/utils/getShortName'
import RMarkdown from 'presentation/hospital/components/RMarkdown'
import { getStatusInfo } from 'presentation/utils/service-status'
import { getSurgicalOrderStatusEnumByLabel } from 'presentation/utils/surgical-order-status'
import { HorizontalActionMenu } from './Tabs/HorizontalActionMenu'

type Props = {
  surgicalOrder: SurgicalOrderModel
  availableHealthInsurances: HealthInsurancePlans[]
  openRemakeModal: () => void
  openGuidesModal: () => void
  isSolicitation?: boolean
} & WithLoadingProps

export const SurgicalOrderLayout = WithLoading(
  ({
    surgicalOrder,
    setIsLoading,
    isLoading,
    openRemakeModal,
    openGuidesModal,
    availableHealthInsurances
  }: Props) => {
    const history = useHistory()
    const [surgicalOrderNoticeCard, setSurgicalOrderNoticeCard] =
      useState<LoadSurgicalOrderNoticeCard.Model>()

    const renderPendencyButton = () => (
      <S.TopContainer>
        <ButtonNew
          className="btn-generate-pendency"
          size="large"
          type="button"
          onClick={() =>
            history.push('/pedido/gerar-pendencia', {
              id: surgicalOrder.surgical_order_id
            })
          }
        >
          Gerar nova pendência
        </ButtonNew>
      </S.TopContainer>
    )

    const mainProcedure =
      surgicalOrderNoticeCard?.data?.data?.card?.procedures?.filter(
        (item: SurgicalOrderProcedureModel) => {
          return item.isMain === true
        }
      )

    const surgicalPendencyService = useServices().surgicalPendency
    const [showPendencyButton, setShowPendencyButton] = useState<boolean>(true)
    const [changeStatusVisible, setChangeStatusVisible] =
      useState<boolean>(false)
    const [pendencies, setPendencies] = useState() as any
    const [timeLineItems, setTimeLineItems] = useState() as any
    const [selectedPendencyHistory, setSelectedPendencyHistory] =
      useState() as any
    const [showEligibility, setShowEligibility] = useState<boolean>(false)
    const [showAuthorization, setShowAuthorization] = useState<boolean>(false)
    const [showPendencies, setShowPendencies] = useState<boolean>(true)
    const [showTimeLine, setShowTimeLine] = useState<boolean>(false)
    const [pendencyOrderId, setPendencyOrderId] = useState()
    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [cancelSolicitationVisible, setCancelSolicitationVisible] =
      useState<boolean>(false)

    const activeMenuItem = showPendencies
      ? 'pendencias'
      : showTimeLine
      ? 'linha-tempo'
      : showEligibility
      ? 'elegibilidade'
      : showAuthorization
      ? 'autorizacao'
      : 'pendencias'

    async function loadSurgicalPendencies(surgical_order_id: number) {
      const response = await surgicalPendencyService.loadSurgicalPendency(
        surgical_order_id
      )

      if (response) {
        setPendencies(response.data)
      } else {
        toast.error('Falha ao buscar pendências')
      }
    }

    async function loadHelpPendencyHistory(surgical_pendency_id: number) {
      try {
        setIsLoading(true)
        const response = await surgicalPendencyService.loadHelpPendencyHistory(
          surgical_pendency_id
        )

        response.data.historic.reverse()
        setSelectedPendencyHistory({
          ...response.data,
          patient_id: surgicalOrder.patient_id
        })
        setIsLoading(false)
      } catch {
        toast.error('Ocorreu um erro ao carregar a pendência')
      } finally {
        setIsLoading(false)
      }
    }

    async function loadAuthorizedCommunicationHistory(
      surgical_pendency_id: number
    ) {
      try {
        setIsLoading(true)
        const response =
          await surgicalPendencyService.loadAuthorizedCommunicationHistory(
            surgical_pendency_id
          )

        response.data.historic.reverse()
        setSelectedPendencyHistory({
          ...response.data,
          patient_id: surgicalOrder.patient_id
        })
      } catch {
        toast.error('Ocorreu um erro ao carregar a Comunicação autorizada')
      } finally {
        setIsLoading(false)
      }
    }

    async function loadSurgicalPendencyHistory(surgical_pendency_id: number) {
      try {
        setIsLoading(true)
        const response =
          await surgicalPendencyService.loadSurgicalPendencyHistory(
            surgical_pendency_id
          )

        response.data.historic.reverse()
        response.data.historic.sort((a: any, b: any) => {
          const aPriority = a.is_timeline && a.profile === 'DOCTOR' ? 1 : 0
          const bPriority = b.is_timeline && b.profile === 'DOCTOR' ? 1 : 0
          if (aPriority !== bPriority) {
            return bPriority - aPriority
          }
          const dateA = moment(a.createdAt).valueOf()
          const dateB = moment(b.createdAt).valueOf()
          return dateA - dateB
        })
        setSelectedPendencyHistory({
          ...response.data,
          patient_id: surgicalOrder.patient_id
        })
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        toast.error('Falha ao buscar dados da linha do tempo da pendência')
      }
    }

    function loadSurgicalPendency(
      surgical_pendency_id: number,
      pendencyType?: PendencyTypes
    ) {
      switch (pendencyType) {
        case PendencyTypes.HELP_CARD:
          loadHelpPendencyHistory(surgical_pendency_id)
          break

        case PendencyTypes.AUTHORIZED_COMMUNICATION:
          loadAuthorizedCommunicationHistory(surgical_pendency_id)
          break

        case PendencyTypes.DOCTOR_COMMUNICATION:
          loadSurgicalPendencyHistory(surgical_pendency_id)
          break

        default:
          loadSurgicalPendencyHistory(surgical_pendency_id)
          break
      }
    }

    async function loadSurgicalOrderTimeLine(surgical_order_id: number) {
      const response = await surgicalPendencyService.loadSurgicalOrderTimeLine(
        surgical_order_id
      )
      if (response) {
        setTimeLineItems(response.data)
      } else {
        toast.error('Falha ao buscar dados da linha do tempo do pedido')
      }
    }

    async function loadSurgicalOrderNoticeCard(surgical_order_id?: number) {
      try {
        setIsLoading(true)
        const response =
          await surgicalPendencyService.loadSurgicalOrderNoticeCard(
            surgical_order_id || surgicalOrder.surgical_order_id!
          )

        setSurgicalOrderNoticeCard(response)

        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        toast.error('Falha ao buscar dados do pedido cirúrgico.')
      }
    }

    useEffect(() => {
      loadSurgicalPendencies(surgicalOrder.surgical_order_id!)
      loadSurgicalOrderNoticeCard()
      loadSurgicalOrderTimeLine(surgicalOrder.surgical_order_id!)
    }, [])

    const handleOpenFinishOrderEdit = () => {
      const statusInfo = getStatusInfo(
        getSurgicalOrderStatusEnumByLabel(
          (surgicalOrderNoticeCard?.data as any)?.card?.active_status
        )
      )

      const status = surgicalOrderNoticeCard?.data?.data?.card?.active_status

      const surgery = {
        orderId: surgicalOrder.surgical_order_id,
        title: mainProcedure?.[0]?.description,
        status: status,
        unit: surgicalOrder.hospital?.name,
        date: moment.utc(surgicalOrder.createdAt).format('DD/MM/YYYY'),
        doctorName: surgicalOrder?.doctor?.name,
        patientName: surgicalOrder?.patient?.name,
        color: statusInfo ? statusInfo.color : undefined,
        patientEmail: surgicalOrder.patient?.email,
        patientPhone: surgicalOrder.patient?.phone,
        doctorEmail: surgicalOrder.doctor?.email,
        doctorPhone: surgicalOrder.doctor?.phone,
        procedure: surgicalOrder.procedure,
        type: 'Cirurgia'
      }

      history.push('/pedido/finalizar', {
        id: surgicalOrder.surgical_order_id,
        surgery
      })
    }

    const handleOpenActiveOrderReview = () => {
      if (surgicalOrder?.isSolicitation) {
        history.push('/solicitacao/resumo', {
          id: surgicalOrder.surgical_order_id
        })
      } else {
        history.push('/pedido/resumo', {
          id: surgicalOrder.surgical_order_id,
          oncology_or_research: (
            surgicalOrderNoticeCard?.data?.data?.card as any
          )?.oncology_or_research
        })
      }
    }

    function handleMenuItemClick(itemId: string) {
      setShowPendencies(itemId === 'pendencias')
      setShowTimeLine(itemId === 'linha-tempo')
      setShowEligibility(itemId === 'elegibilidade')
      setShowAuthorization(itemId === 'autorizacao')

      if (itemId === 'pendencias') {
        setShowPendencyButton(true)
      }

      if (itemId !== 'pendencias') {
        setShowPendencyButton(false)
      }
    }

    function getEligibilityStatus() {
      if (
        surgicalOrderNoticeCard?.data?.data?.card?.health_insurance.name ===
        'PARTICULAR'
      ) {
        return {
          title: 'Elegível',
          color: '#038E83'
        }
      }

      const healthInsuranceStatus =
        surgicalOrderNoticeCard?.data?.data?.card?.health_insurance
          .health_insurance_status[0]

      switch (healthInsuranceStatus?.status) {
        case HealthInsuranceEnum.ELIGIBLE:
          return {
            title: 'Elegível',
            color: '#038E83'
          }
        case HealthInsuranceEnum.ELIGIBLE_PENDING:
          return {
            title: 'Elegibilidade pendente',
            color: '#FFC107'
          }
        case HealthInsuranceEnum.INELIGIBLE:
          return {
            title: 'Não elegível',
            color: '#D32F2F'
          }
      }
    }

    getEligibilityStatus()
    const [otherSurgeriesVisible, setOtherSurgeriesVisible] = useState(false)
    return (
      <>
        <S.HeaderWrapper>
          <S.CardHeader>
            <S.ProcedureTextWrapper>
              <div>
                <S.SubTitle> Procedimento</S.SubTitle>
                <HeadingNew
                  as="h1"
                  color={'primary600'}
                  weight={'bold'}
                  size={'large'}
                >
                  {!!mainProcedure &&
                    capitalizeText(mainProcedure[0]?.description)}
                </HeadingNew>
              </div>

              <S.OtherSurgeriesContainer>
                <S.FlexGap>
                  <OtherSurgeriesIcon />
                  <SupportTextNew weight="bold" color="black">
                    Cirurgias em aberto
                  </SupportTextNew>
                </S.FlexGap>
                <S.FlexGap>
                  <SupportTextNew weight="semiBold">
                    Nº aviso:{' '}
                    {
                      surgicalOrderNoticeCard?.data?.data?.card
                        ?.surgical_order_id
                    }{' '}
                    <SupportTextNew
                      as="span"
                      size="xsmall"
                      color="neutral800"
                      weight="bold"
                    >
                      (Este aviso){' '}
                    </SupportTextNew>
                  </SupportTextNew>

                  <div style={{ lineHeight: 1.3 }}>
                    <S.Underscore
                      onClick={() =>
                        setOtherSurgeriesVisible(!otherSurgeriesVisible)
                      }
                    >
                      Ver outros avisos
                    </S.Underscore>
                    <OtherSurgeries
                      otherSurgeries={
                        surgicalOrderNoticeCard?.data?.data?.card
                          .other_surgeries
                      }
                      setOtherSurgeriesVisible={setOtherSurgeriesVisible}
                      otherSurgeriesVisible={otherSurgeriesVisible}
                      loadSurgicalOrderNoticeCard={loadSurgicalOrderNoticeCard}
                      loadSurgicalPendencies={loadSurgicalPendencies}
                      loadSurgicalOrderTimeLine={loadSurgicalOrderTimeLine}
                    />
                  </div>
                </S.FlexGap>
              </S.OtherSurgeriesContainer>

              <S.FlexContainer>
                {surgicalOrderNoticeCard?.data?.data?.card
                  ?.finalize_surgical_order
                  .password_max_date_validation_status ===
                PasswordMaxDateValidationStatus.EXPIRED ? (
                  <S.TagContainer>
                    <S.AlertIconWrapper>
                      <AlertIcon />
                    </S.AlertIconWrapper>
                    <S.TagDescription>Senha vencida</S.TagDescription>
                  </S.TagContainer>
                ) : (
                  ''
                )}

                <S.TagContainer>
                  <S.Ball colorBall={getEligibilityStatus()?.color} />
                  <S.TagDescription>
                    {getEligibilityStatus()?.title}
                  </S.TagDescription>
                </S.TagContainer>

                <S.TagContainer>
                  <S.Ball
                    colorBall={
                      surgicalOrderNoticeCard?.data?.data?.card
                        ?.scheduling_status ===
                      SurgicalOrderStatus.CANCELLATION_REQUEST
                        ? ''
                        : surgicalOrderNoticeCard?.data?.data?.card
                            ?.scheduling_status !==
                            SurgicalOrderStatus.SCHEDULED && '#FF9E22'
                    }
                  />
                  <S.TagDescription>
                    {surgicalOrderNoticeCard?.data?.data?.card
                      ?.scheduling_status ===
                    SurgicalOrderStatus.CANCELLATION_REQUEST
                      ? SurgicalOrderStatusReturnEnum.CANCELLATION_REQUEST
                      : surgicalOrderNoticeCard?.data?.data?.card
                          ?.scheduling_status !== SurgicalOrderStatus.SCHEDULED
                      ? 'Não agendado'
                      : 'Agendado'}
                  </S.TagDescription>
                </S.TagContainer>

                <StatusTag
                  variant={
                    surgicalOrderNoticeCard?.data?.data?.footer?.status ===
                    SurgicalOrderStatusReturnEnum.CANCELLATION_REQUEST
                      ? 'gray'
                      : surgicalOrderNoticeCard?.data?.data?.footer?.status ===
                        SurgicalOrderStatusReturnEnum.CANCELLED
                      ? 'gray'
                      : surgicalOrderNoticeCard?.data?.data?.footer?.status !==
                        AuthorizationStatusTranslated.AUTHORIZED
                      ? 'orange'
                      : 'green'
                  }
                >
                  {surgicalOrderNoticeCard?.data?.data?.card?.active_status ===
                  SurgicalOrderStatusReturnEnum.CANCELLATION_REQUEST
                    ? 'Cancelamento Solicitado'
                    : surgicalOrderNoticeCard?.data?.data?.card
                        ?.active_status ===
                      SurgicalOrderStatusReturnEnum.CANCELLED
                    ? 'Pedido cancelado'
                    : surgicalOrderNoticeCard?.data?.data?.footer?.status}
                </StatusTag>

                {surgicalOrderNoticeCard?.data?.data?.card?.is_package && (
                  <StatusTag variant="gray">Pacote cirúrgico</StatusTag>
                )}
              </S.FlexContainer>
            </S.ProcedureTextWrapper>
          </S.CardHeader>

          <S.InfoContainer>
            <div>
              <S.LabelStrong>Paciente</S.LabelStrong>
              <S.TextDescription>
                {surgicalOrderNoticeCard?.data?.data?.card?.patient.name &&
                  convertNameToTitleCase(
                    surgicalOrderNoticeCard?.data?.data?.card?.patient.name
                  )}
              </S.TextDescription>
            </div>

            <div>
              <S.LabelStrong>Médico Responsável</S.LabelStrong>
              <S.TextDescription>
                Dr.(a){' '}
                {surgicalOrderNoticeCard?.data?.data?.card?.doctor?.name &&
                  convertNameToTitleCase(
                    surgicalOrderNoticeCard?.data?.data?.card?.doctor?.name
                  )}
              </S.TextDescription>
            </div>

            <div>
              <S.LabelStrong>Convênio</S.LabelStrong>
              <S.TextDescription>
                {
                  surgicalOrderNoticeCard?.data?.data?.card?.health_insurance
                    ?.name
                }
              </S.TextDescription>
            </div>

            <div>
              <S.LabelStrong>Unidade</S.LabelStrong>
              <S.TextDescription>
                {surgicalOrderNoticeCard?.data?.data?.card?.hospital?.name}
              </S.TextDescription>
            </div>

            <div>
              <S.LabelStrong>Data da cirurgia</S.LabelStrong>
              {surgicalOrderNoticeCard?.data?.data?.card?.scheduling_status && (
                <S.TextDescription>
                  {surgicalOrderNoticeCard?.data?.data?.card?.scheduling_date[0]
                    ?.scheduled_date
                    ? moment
                        .utc(
                          surgicalOrderNoticeCard?.data?.data?.card
                            ?.scheduling_date[0]?.scheduled_date
                        )
                        .locale('pt-br')
                        .format('DD/MM/YYYY') +
                      ' - ' +
                      moment
                        .utc(
                          surgicalOrderNoticeCard?.data?.data?.card
                            ?.scheduling_date[0]?.scheduled_date
                        )
                        .locale('pt-br')
                        .format('LT')
                    : 'Não agendada'}
                </S.TextDescription>
              )}
            </div>

            <div>
              <S.LabelStrong>Criado por</S.LabelStrong>
              <S.CreatedByContainer style={{ alignItems: 'flex-start' }}>
                {surgicalOrderNoticeCard?.data?.data?.card?.created_by && (
                  <S.CreatedByProfile>
                    {getNameInitials(
                      surgicalOrderNoticeCard.data.data.card.created_by
                    )}
                  </S.CreatedByProfile>
                )}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <S.TextDescription>
                    {surgicalOrderNoticeCard?.data?.data?.card?.doctor?.name ===
                      surgicalOrderNoticeCard?.data?.data?.card?.created_by &&
                      'Dr.(a) '}

                    {surgicalOrderNoticeCard?.data?.data?.card?.created_by &&
                      getShortName(
                        surgicalOrderNoticeCard?.data?.data?.card?.created_by
                      )}
                  </S.TextDescription>
                  {surgicalOrderNoticeCard?.data?.data?.card?.created_at && (
                    <>
                      <S.MessageDate>
                        {moment
                          .utc(
                            surgicalOrderNoticeCard.data.data.card.created_at
                          )
                          .locale('pt-br')
                          .format('DD/MM/YYYY [às] HH[h]mm')}
                      </S.MessageDate>
                      <S.RelativeTimeText>
                        {moment
                          .utc(
                            surgicalOrderNoticeCard.data.data.card.created_at
                          )
                          .local(true)
                          .locale('pt-br')
                          .fromNow()}
                      </S.RelativeTimeText>
                    </>
                  )}
                </div>
              </S.CreatedByContainer>
            </div>
            <div>
              <S.LabelStrong>Ultima interação</S.LabelStrong>
              <S.CreatedByContainer style={{ alignItems: 'flex-start' }}>
                {surgicalOrder?.last_integration?.name && (
                  <S.CreatedByProfile>
                    {getNameInitials(surgicalOrder.last_integration.name)}
                  </S.CreatedByProfile>
                )}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <S.TextDescription>
                    {surgicalOrder?.doctor?.name ===
                      surgicalOrder?.last_integration?.name && 'Dr.(a) '}

                    {surgicalOrder?.last_integration?.name &&
                      getShortName(surgicalOrder.last_integration.name)}
                  </S.TextDescription>
                  {surgicalOrder?.last_integration?.date && (
                    <>
                      <S.MessageDate>
                        {moment
                          .utc(surgicalOrder.last_integration.date)
                          .locale('pt-br')
                          .format('DD/MM/YYYY [às] HH[h]mm')}
                      </S.MessageDate>
                      <S.RelativeTimeText>
                        {moment
                          .utc(surgicalOrder.last_integration.date)
                          .local(true)
                          .locale('pt-br')
                          .fromNow()}
                      </S.RelativeTimeText>
                    </>
                  )}
                </div>
              </S.CreatedByContainer>
            </div>
          </S.InfoContainer>
        </S.HeaderWrapper>

        <S.ContentWrapper>
          <HorizontalActionMenu
            activeItem={activeMenuItem}
            onItemClick={handleMenuItemClick}
            handleOpenRemakeModal={openRemakeModal}
            handleOpenGuidesModal={openGuidesModal}
            handleOpenFinishOrderEdit={handleOpenFinishOrderEdit}
            handleOpenActiveOrderReview={handleOpenActiveOrderReview}
          />
          {showPendencies && pendencies && (
            <S.ColumnsContainer>
              <S.LeftContainer>
                <PendenciesTab
                  pendencies={pendencies?.data}
                  loadSurgicalPendency={loadSurgicalPendency}
                  setPendencyOrderId={setPendencyOrderId}
                />
              </S.LeftContainer>
              {(selectedPendencyHistory ||
                historyVisible ||
                cancelSolicitationVisible) && (
                <>
                  <S.Separator />
                  <S.CenterContainer>
                    <EventHistory
                      surgicalOrderNoticeCard={surgicalOrderNoticeCard}
                      cancelSolicitationVisible={cancelSolicitationVisible}
                      timeLineItems={timeLineItems.data}
                      selectedPendencyHistory={selectedPendencyHistory}
                      loadSurgicalPendency={loadSurgicalPendency}
                      loadSurgicalPendencies={loadSurgicalPendencies}
                      setIsLoading={setIsLoading}
                      pendencyOrderId={pendencyOrderId}
                    />
                  </S.CenterContainer>
                  <S.Separator />
                  <S.RightContainer>
                    {selectedPendencyHistory?.type !==
                      PendencyTypes.DOCTOR_COMMUNICATION && (
                      <DocumentsAttached
                        title="Documentos anexados"
                        surgicalPendencyId={
                          selectedPendencyHistory?.surgical_pendency_id
                        }
                        surgicalOrderId={
                          selectedPendencyHistory?.surgical_order_id
                        }
                        refreshDocuments={loadSurgicalPendency}
                        documents={selectedPendencyHistory?.documents}
                        topButton={showPendencyButton && renderPendencyButton()}
                      />
                    )}
                  </S.RightContainer>
                </>
              )}
              {!selectedPendencyHistory &&
                !historyVisible &&
                !cancelSolicitationVisible &&
                showPendencyButton && (
                  <>
                    <S.RightContainer>
                      {renderPendencyButton()}
                    </S.RightContainer>
                  </>
                )}
            </S.ColumnsContainer>
          )}
          {showTimeLine && timeLineItems && (
            <S.ColumnsContainer>
              <S.LeftContainer>
                <TimeLineTab
                  timeLineItems={timeLineItems.data}
                  loadSurgicalPendency={loadSurgicalPendency}
                  setSelectedPendencyHistory={setSelectedPendencyHistory}
                  setHistoryVisible={setHistoryVisible}
                  setCancelSolicitationVisible={setCancelSolicitationVisible}
                />
              </S.LeftContainer>

              {(selectedPendencyHistory ||
                historyVisible ||
                cancelSolicitationVisible) && (
                <>
                  <S.Separator />
                  <S.CenterContainer>
                    <EventHistory
                      surgicalOrderNoticeCard={surgicalOrderNoticeCard}
                      cancelSolicitationVisible={cancelSolicitationVisible}
                      timeLineItems={timeLineItems.data}
                      selectedPendencyHistory={selectedPendencyHistory}
                      loadSurgicalPendency={loadSurgicalPendency}
                      loadSurgicalPendencies={loadSurgicalPendencies}
                      setIsLoading={setIsLoading}
                      pendencyOrderId={pendencyOrderId}
                    />
                  </S.CenterContainer>
                  <S.Separator />
                  <S.RightContainer>
                    {selectedPendencyHistory?.type !==
                      PendencyTypes.DOCTOR_COMMUNICATION && (
                      <DocumentsAttached
                        title="Documentos anexados"
                        surgicalPendencyId={
                          selectedPendencyHistory?.surgical_pendency_id
                        }
                        surgicalOrderId={
                          selectedPendencyHistory?.surgical_order_id
                        }
                        refreshDocuments={loadSurgicalPendency}
                        documents={selectedPendencyHistory?.documents}
                      />
                    )}
                  </S.RightContainer>
                </>
              )}
            </S.ColumnsContainer>
          )}

          {showEligibility && (
            <S.ColumnsContainer>
              <S.Separator />
              <EligibilityTab
                surgicalOrderNoticeCard={surgicalOrderNoticeCard}
                availableHealthInsurances={availableHealthInsurances}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                loadSurgicalOrderNoticeCard={loadSurgicalOrderNoticeCard}
              />
            </S.ColumnsContainer>
          )}

          {showAuthorization && (
            <S.ColumnsContainer>
              <AuthorizationTab
                surgicalOrderNoticeCard={surgicalOrderNoticeCard}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                loadSurgicalOrderNoticeCard={loadSurgicalOrderNoticeCard}
              />
            </S.ColumnsContainer>
          )}
        </S.ContentWrapper>
        <ModalChangeStatus
          changeStatusVisible={changeStatusVisible}
          setChangeStatusVisible={setChangeStatusVisible}
          loadSurgicalOrderNoticeCard={loadSurgicalOrderNoticeCard}
          activeStatus={
            surgicalOrderNoticeCard?.data?.data?.card?.active_status
          }
          surgicalOrderId={
            surgicalOrderNoticeCard?.data?.data?.card?.surgical_order_id
          }
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      </>
    )
  }
)

const OtherSurgeries = ({
  otherSurgeries,
  otherSurgeriesVisible,
  setOtherSurgeriesVisible,
  loadSurgicalOrderNoticeCard,
  loadSurgicalPendencies,
  loadSurgicalOrderTimeLine
}: any) => {
  const wrapperRef = useRef(null) as any

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOtherSurgeriesVisible(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  function getFirstAndLastName(fullName: string) {
    const names = fullName?.trim().split(' ')
    if (names?.length > 2) {
      return `${names[0]} ${names[names?.length - 1]}`
    }

    return fullName
  }

  const handleOpenOrderDetails = (surgical_order_id: number) => {
    loadSurgicalOrderNoticeCard(surgical_order_id)
    loadSurgicalOrderTimeLine(surgical_order_id)
    loadSurgicalPendencies(surgical_order_id)
  }

  return (
    <div ref={wrapperRef}>
      {otherSurgeriesVisible ? (
        <S.OtherSurgeriesWrapper>
          <p style={{ padding: '18px 18px 0px' }}>
            <SupportTextNew
              color="neutral900"
              size="small"
              weight="bold"
              style={{ marginBottom: '10px' }}
            >
              {otherSurgeries?.length} cirurgias em aberto
            </SupportTextNew>
          </p>

          <div>
            <div>
              {otherSurgeries?.length > 0 ? (
                <S.OtherSurgeriesScroll>
                  {otherSurgeries?.map((item: any) => (
                    <S.CardContainer
                      onClick={() =>
                        handleOpenOrderDetails(item.surgical_order_id)
                      }
                      key={item.surgical_order_id}
                    >
                      <SupportTextNew
                        weight="semiBold"
                        className="order"
                        size="small"
                        color="neutral800"
                      >
                        Nº aviso: {item.surgical_order_id}
                      </SupportTextNew>
                      <SupportTextNew
                        weight="semiBold"
                        size="xsmall"
                        color="neutral800"
                        className="doctor"
                      >
                        Médico (a): {getFirstAndLastName(item.doctor.name)}
                      </SupportTextNew>
                      <SupportTextNew
                        weight="semiBold"
                        size="xsmall"
                        color="neutral800"
                        className="unit"
                      >
                        Unidade: {item.hospital.name}
                      </SupportTextNew>
                    </S.CardContainer>
                  ))}
                </S.OtherSurgeriesScroll>
              ) : (
                <p>Nenhum dado disponível</p>
              )}
            </div>
          </div>
        </S.OtherSurgeriesWrapper>
      ) : (
        <> </>
      )}
    </div>
  )
}

const ModalChangeStatus = ({
  changeStatusVisible,
  setChangeStatusVisible,
  activeStatus,
  surgicalOrderId,
  loadSurgicalOrderNoticeCard,
  setIsLoading,
  isLoading
}: any) => {
  const orderStatusOptions = [
    { value: 'REVIEW', label: 'Revisão' },
    { value: 'PRE_SCHEDULE', label: 'Pré agendamento' },
    { value: 'OPME_QUOTATION', label: 'Cotação de OPME' },
    { value: 'CRMO', label: 'Na CRMO' },
    { value: 'HEALTH_INSURANCE_APPROVE', label: 'No convênio' },
    { value: 'CRMO_VALIDATION', label: 'Validação CRMO' }
  ]

  const formatedStatusOptions = orderStatusOptions.filter((status: any) => {
    return status.label !== activeStatus
  })

  const [selectedStatus, setSelectedStatus] = useState('')

  const surgicalOrderService = useServices().surgicalOrder

  async function changeOrderStatusModal() {
    try {
      setIsLoading(true)

      const response = await surgicalOrderService.createSurgicalOrderStatus({
        surgical_order_id: surgicalOrderId,
        status: selectedStatus
      })

      if (response.statusCode === 400) {
        return toast.error('Falha na transfêrencia de fase.')
      }

      loadSurgicalOrderNoticeCard()

      toast.success('Transferência de fase realizada com sucesso.')
      setChangeStatusVisible(false)
    } catch (error) {
      toast.error('Falha na transfêrencia de fase.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Modal
        show={changeStatusVisible}
        style={{ display: 'block', width: '480px', padding: 20 }}
        close={() => setChangeStatusVisible(false)}
        preventAutomateClose
      >
        <S.ModalInfo>
          <S.ModalTitle>Transferir de fase</S.ModalTitle>
          <CloseIcon onClick={() => setChangeStatusVisible(false)} />
        </S.ModalInfo>
        <DividerNew />
        <TextFieldNew
          label="Fase atual do processo"
          placeholder="Médico responsável"
          style={{ maxWidth: '500px' }}
          value={activeStatus}
          disabled
        />

        <SelectFieldNew
          style={{ marginTop: '30px' }}
          label="Nova fase"
          // required={true}
          value={selectedStatus}
          items={formatedStatusOptions}
          onInputChange={(value) => setSelectedStatus(value)}
        />

        <S.StatusButtonPanel>
          <ButtonNew
            variant="text"
            onClick={() => setChangeStatusVisible(false)}
          >
            Cancelar
          </ButtonNew>

          <ButtonNew
            onClick={changeOrderStatusModal}
            disabled={!selectedStatus}
          >
            Transferir
          </ButtonNew>
        </S.StatusButtonPanel>
      </Modal>
      <LoadingModal show={isLoading} />
    </>
  )
}

const EventHistory = ({
  selectedPendencyHistory,
  pendencyOrderId,
  loadSurgicalPendency,
  loadSurgicalPendencies,
  setIsLoading,
  timeLineItems,
  cancelSolicitationVisible,
  surgicalOrderNoticeCard
}: PendencyHistoryType) => {
  let tagColor = '' as 'orange' | 'purple' | 'green'
  let tagText

  if (selectedPendencyHistory?.status === 'PENDENT') {
    ;(tagColor = 'orange'), (tagText = 'À resolver')
  }
  if (selectedPendencyHistory?.status === 'IN_PROGRESS') {
    ;(tagColor = 'purple'), (tagText = 'Em andamento')
  }
  if (selectedPendencyHistory?.status === 'RESOLVED') {
    ;(tagColor = 'green'), (tagText = 'Resolvido')
  }

  const surgicalPendencyService = useServices().surgicalPendency
  const history = useHistory()

  function getNameInitials(name: string) {
    return name
      ?.replace(/[a-z]+/g, '')
      .split('')
      .filter(function (el) {
        return el !== ' '
      })
      .map((n) => n[0])
      .slice(0, 2)
      .join('')
  }

  const validationSchema = yup.object().shape({
    observation: yup.string().required().max(4000)
  })

  const { handleChange, submitForm, resetForm, values, isValid } = useFormik({
    initialValues: {
      observation: ''
    },
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: async (formValues) => {
      try {
        setIsLoading(true)
        if (selectedPendencyHistory.status === 'RESOLVED') {
          setIsLoading(false)
          return toast.error('Não é possível comentar uma pendência resolvida')
        }

        switch (selectedPendencyHistory.type) {
          case PendencyTypes.HELP_CARD:
            await surgicalPendencyService.createHelpPendencyMessage({
              surgical_pendency_id:
                selectedPendencyHistory.surgical_pendency_id,
              message: formValues.observation
            })
            break

          case PendencyTypes.AUTHORIZED_COMMUNICATION:
            await surgicalPendencyService.createAuthorizedCommunicationMessage({
              surgical_pendency_id:
                selectedPendencyHistory.surgical_pendency_id,
              message: formValues.observation
            })
            break

          case PendencyTypes.DOCTOR_COMMUNICATION:
            await surgicalPendencyService.answerDoctorCommunication({
              surgical_pendency_id:
                selectedPendencyHistory.surgical_pendency_id,
              message: formValues.observation
            })
            break

          default:
            await surgicalPendencyService.addSurgicalPendency({
              surgical_order_id: selectedPendencyHistory.surgical_order_id,
              parentPendencyId: selectedPendencyHistory.surgical_pendency_id,
              observation: formValues.observation,
              type: PendencyType.AUTHORIZATION,
              doctor_id: selectedPendencyHistory.doctor_id,
              patient_id: selectedPendencyHistory.patient_id
            })
            break
        }

        loadSurgicalPendency(
          selectedPendencyHistory.surgical_pendency_id,
          selectedPendencyHistory.type
        )
        loadSurgicalPendencies(selectedPendencyHistory.surgical_order_id)

        resetForm()
        toast.success('Comentário adicionado')
      } catch (e: any) {
        toast.error(e.message)
      } finally {
        setIsLoading(false)
      }
    }
  })

  async function resolvePendency() {
    try {
      setIsLoading(true)

      switch (selectedPendencyHistory.type) {
        case PendencyTypes.HELP_CARD:
          await surgicalPendencyService?.finishHelpPendency({
            surgical_pendency_id: selectedPendencyHistory.surgical_pendency_id
          })
          break

        case PendencyTypes.AUTHORIZED_COMMUNICATION:
          await surgicalPendencyService?.finishAuthorizedCommunication({
            surgical_pendency_id: selectedPendencyHistory.surgical_pendency_id
          })
          break

        default:
          await surgicalPendencyService?.finishSurgicalPendency({
            surgical_pendency_id: selectedPendencyHistory.surgical_pendency_id
          })
          break
      }

      loadSurgicalPendency(
        selectedPendencyHistory.surgical_pendency_id,
        selectedPendencyHistory.type
      )
      loadSurgicalPendencies(selectedPendencyHistory.surgical_order_id)

      setIsLoading(false)
      toast.success('Pendência resolvida')
      return
    } catch (error) {
      setIsLoading(false)
      return toast.error('Ocorreu um erro ao marcar como resolvida')
    }
  }

  function getNameFromPendencySendBy(
    sendBy: ResponsibleSurgicalPendencyTypeEnum
  ) {
    return ResponsibleSurgicalPendency[sendBy]
  }

  const filteredTimeLineItems = Array.isArray(timeLineItems)
    ? timeLineItems.filter(
        (item: any) =>
          item.action_type ===
            SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER ||
          item.action_type ===
            SurgicalTimeLineActions.CANCELED_SCHEDULING_SOLICITATION
      )
    : []

  function getPendencyTitle() {
    switch (selectedPendencyHistory?.type) {
      case PendencyTypes.HELP_CARD:
        return `Preciso de ajuda ${('000' + pendencyOrderId).slice(-3)}`

      case PendencyTypes.AUTHORIZED_COMMUNICATION:
        return 'Comunicar Autorização'

      case PendencyTypes.DOCTOR_COMMUNICATION:
        return `Conversa ${('000' + pendencyOrderId).slice(-3)}`

      default:
        return `Pendência ${
          pendencyOrderId ? ('000' + pendencyOrderId).slice(-3) : ''
        }`
    }
  }

  return (
    <>
      <S.EventHeader>
        {cancelSolicitationVisible && !selectedPendencyHistory ? (
          <S.StrongTitle>Solicitação do cancelamento</S.StrongTitle>
        ) : (
          <S.StrongTitle>{getPendencyTitle()}</S.StrongTitle>
        )}
        {selectedPendencyHistory && (
          <>
            <StatusTag variant={tagColor}>{tagText}</StatusTag>
            {selectedPendencyHistory.type !== PendencyTypes.HELP_CARD &&
              selectedPendencyHistory.type !==
                PendencyTypes.AUTHORIZED_COMMUNICATION && (
                <S.MessageSendBy>
                  Enviado para:{' '}
                  <S.MessageSendByText>
                    {getNameFromPendencySendBy(selectedPendencyHistory.send_by)}
                  </S.MessageSendByText>
                </S.MessageSendBy>
              )}
          </>
        )}
      </S.EventHeader>
      <DividerNew />

      {selectedPendencyHistory && (
        <S.HistoryContainer>
          {selectedPendencyHistory?.historic?.map((item, index) => {
            return (
              <S.HistoryItem key={index}>
                <S.PendencyAuthorContainer>
                  <S.BallCounter color={'#038E83'}>
                    {getNameInitials(item?.responsible)}
                  </S.BallCounter>
                  <div>
                    <S.AuthorMessage>
                      {item.profile === Profile.DOCTOR.toUpperCase() && (
                        <>Dr.(a)</>
                      )}{' '}
                      {convertNameToTitleCase(item.responsible)}{' '}
                      <S.CircleSeparator />{' '}
                      {
                        ProfileLocated[
                          item.profile.toLowerCase() as keyof typeof ProfileLocated
                        ]
                      }
                    </S.AuthorMessage>
                    <S.MessageDate>
                      {moment
                        .utc(item.createdAt)
                        .locale('pt-br')
                        .format('DD [de] MMMM [de] YYYY [às] HH[h]mm')}
                    </S.MessageDate>
                  </div>
                </S.PendencyAuthorContainer>

                <S.HistoryMessage>
                  <RMarkdown rawText={item.message} />
                </S.HistoryMessage>
                <DividerNew marginBottom="0" />
              </S.HistoryItem>
            )
          })}
        </S.HistoryContainer>
      )}
      {cancelSolicitationVisible && !selectedPendencyHistory && (
        <S.HistoryContainer>
          {filteredTimeLineItems?.map((item: any, index: any) => {
            return (
              <S.HistoryItem key={index}>
                <S.PendencyAuthorContainer>
                  <S.BallCounter color={'#038E83'}>
                    {getNameInitials(item?.name)}
                  </S.BallCounter>
                  <div>
                    <S.AuthorMessage>
                      {item.persona === Profile.DOCTOR.toUpperCase() && (
                        <>Dr.(a)</>
                      )}{' '}
                      {convertNameToTitleCase(item.name)} <S.CircleSeparator />{' '}
                      {
                        ProfileLocated[
                          item.persona.toLowerCase() as keyof typeof ProfileLocated
                        ]
                      }
                    </S.AuthorMessage>
                    <S.MessageDate>
                      {moment
                        .utc(item.created_at)
                        .locale('pt-br')
                        .format('DD [de] MMMM [de] YYYY [às] HH[h]mm')}
                    </S.MessageDate>
                  </div>
                </S.PendencyAuthorContainer>

                <S.HistoryMessage>{item.action}</S.HistoryMessage>
                {item.action_type ===
                  SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER && (
                  <ButtonNew
                    variant="default"
                    type="button"
                    size="small"
                    weight="bold"
                    fullWidth={false}
                    onClick={() =>
                      history.push('/pedido/solicitacao-cancelamento', {
                        surgical_order_id:
                          surgicalOrderNoticeCard?.data?.data?.card
                            ?.surgical_order_id,
                        patient_id:
                          surgicalOrderNoticeCard?.data?.data?.card?.patient
                            ?.patient_id,
                        surgical_time_line_id: item.surgical_time_line_id,
                        requester:
                          surgicalOrderNoticeCard?.data?.data?.card?.created_by
                      })
                    }
                    style={{
                      marginTop: '16px',
                      maxWidth: '145px',
                      fontSize: '12px'
                    }}
                  >
                    Ver mais detalhes
                  </ButtonNew>
                )}

                <DividerNew marginBottom="0" />
              </S.HistoryItem>
            )
          })}
        </S.HistoryContainer>
      )}
      {selectedPendencyHistory && (
        <>
          <TextAreaNew
            rows={4}
            name="observation"
            value={values.observation}
            placeholder="Adicione um comentário"
            onChange={handleChange('observation')}
          />
          <SupportTextNew
            size="xsmall"
            color={isValid ? 'neutral400' : 'danger300'}
            style={{ textAlign: 'right', marginRight: '5px', marginTop: '3px' }}
          >
            {values.observation.length}/4000
          </SupportTextNew>

          <S.ButtonPanel>
            <ButtonNew
              disabled={selectedPendencyHistory?.status === 'RESOLVED'}
              variant="text"
              onClick={() => resolvePendency()}
            >
              Marcar como resolvida
            </ButtonNew>
            <ButtonNew
              disabled={
                selectedPendencyHistory?.status === 'RESOLVED' || !isValid
              }
              onClick={() => [submitForm()]}
            >
              Enviar comentário
            </ButtonNew>
          </S.ButtonPanel>
        </>
      )}
    </>
  )
}
